import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Button,
} from '@/components/atoms';
import { XIcon } from 'lucide-react';

export interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
  icon?: React.ReactNode;
}

export const StatusModal = ({
  isOpen,
  onClose,
  type,
  title,
  description,
  buttonText,
  onButtonClick,
  icon,
}: StatusModalProps) => {
  const defaultIcon =
    type === 'success' ? (
      <div className="text-8xl mt-10 text-center mb-4">🎉</div>
    ) : (
      <div className="w-16 mt-10 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <XIcon className="w-8 h-8 text-white" />
      </div>
    );

  const buttonVariant = type === 'success' ? 'outline' : 'default';
  const buttonClassName =
    type === 'success'
      ? 'border-green-500 px-8 py-3 rounded-md text-base w-full text-green-500 max-w-md mx-auto hover:bg-green-50'
      : 'px-8 py-3 rounded-md w-full text-base';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="grid w-full px-10 py-10 text-center rounded-2xl">
        <DialogHeader className="text-center">
          {icon || defaultIcon}
          <DialogTitle className="text-2xl text-center font-bold text-black">
            {title}
          </DialogTitle>
          <DialogDescription className="text-base text-center text-muted-foreground mt-2">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="flex w-full justify-center mt-6">
          <Button
            variant={buttonVariant}
            className={buttonClassName}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
